export const GET_STARTED = 'MarketplaceHeroesIndex/GET_STARTED';
export const DOWNLOAD_MATERIALS = 'MarketplaceHeroesIndex/DOWNLOAD_MATERIALS';
export const REGISTER_SUCCESS = 'MarketplaceHeroes/REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'MarketplaceHeroes/REGISTER_FAILURE';
